import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IContact } from "../contactsModal";
import moment from "moment";

export const getAllContacts = createAsyncThunk(
  "Contact/FindAllContact",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindAllContact`,
        {
          ContactName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Contact Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createContact = createAsyncThunk(
  "Contact/InsertContact",
  async (ContactData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/InsertContact`,
        ContactData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Contact logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateContact = createAsyncThunk(
  "Contact/UpdateContact",
  async (ContactData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/UpdateContact`,
        ContactData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Contact logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteContact = createAsyncThunk(
  "Contact/DeleteContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/DeleteContact`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Contact logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getContactByID = createAsyncThunk(
  "Contact/FindByIDContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindByIDContact`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result?.Name ? result?.Name : "",
        Email: result?.Email ? result?.Email : "",
        MobileNo: result?.MobileNo ? result?.MobileNo : "",
        Remarks: result?.Remarks ? result?.Remarks : "",
        InquiryDate: result?.InquiryDate
          ? moment(result?.InquiryDate).toDate()
          : "",
        IsActive: result.IsActive ? 1 : 2,
      } as IContact;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Contact logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveContacts = createAsyncThunk(
  "Contact/FindAllActiveContact",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Contact/FindAllActiveContact`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Contact Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveContact = createAsyncThunk(
  "Contact/ActiveInActiveContact",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/ActiveInActiveContact`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Contact logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ContactImageUpload = createAsyncThunk(
  "Contact/ContactImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/ContactImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Contact logo Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
